import { RcClasses } from '../../../foundation';
export var RcInlineEditableClasses = RcClasses(['label', 'placeholder', 'textField', 'saving'], 'RcInlineEditable');
